import {
  TextArea as ChordsTextArea,
  type TextAreaProps,
} from '~/chords/TextArea';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const TextArea = withClassNameHoc(ChordsTextArea);

export type { TextAreaProps };
